import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutAgencyLink extends Layout {
    panelAgencyLink: Panel;
    sourceAgencyLink: DataSource;
    tableAgencyLink: Table;
}
